/**
 * ユーザーがログインするためのAPIリクエストを送信する
 * - 成功時にJWTトークンを`sessionStorage`に保存
 * - 失敗時にエラーメッセージを投げる
 * 
 * @param {string} username ユーザー名
 * @param {string} password パスワード
 */
export const login = async (username, password) => {
    const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
    });

    if (!res.ok) {
        throw new Error("ログインに失敗しました");
    }

    const data = await res.json();
    // ログイン成功時にトークンをsessionストレージに保存
    sessionStorage.setItem("token", data.token); 
    
};

/**
 * ログイン中のユーザー情報を取得する
 * - JWTをヘッダーに含めて`/auth/me`へリクエスト
 * - 失敗した場合はnullを返す
 * 
 * @returns {Promise<Object|null>} ユーザー情報（失敗時はnull）
 */
export const getUserInfo = async () => {
    const token = sessionStorage.getItem("token"); // ログイン済みならトークンが保存されている
    
    if (!token) return null;

    try {
        const res = await fetch("/api/auth/me", {
            headers: { 
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        });

        

        if (!res.ok) {
            return null; 
        }

        const userData = await res.json();
        return userData;
    } catch (error) {
        return null;
    }

};

/**
 * 認証チェック & 未認証時のリダイレクト処理
 * - トークンがない場合、ログインページへリダイレクト
 * - ユーザー情報を取得し、失敗した場合もログインページへ
 *
 * @param {Function} navigate ナビゲーション関数 (useNavigate)
 * @returns {Promise<Object|null>} ユーザー情報（失敗時はリダイレクト）
 */
export const checkAuthAndRedirect = async (navigate) => {
    const user = await getUserInfo();
    if (!user) {
        sessionStorage.removeItem("token");// トークンを削除
        navigate("/login");
        return null;
    }
    return user;
};

